export default "__VITE_ASSET__D1hcjj6i__";